var React = require('react');

function MobilePhone2Light (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3717_259)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 0a5 5 0 00-5 5v38a5 5 0 005 5h18a5 5 0 005-5V5a5 5 0 00-5-5H15zm21 38V5a3 3 0 00-3-3H15a3 3 0 00-3 3v33h24zm-24 2h24v3a3 3 0 01-3 3H15a3 3 0 01-3-3v-3zm12 1.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_3717_259"},React.createElement("path",{"d":"M0 0h48v48H0z"})))]);
}

MobilePhone2Light.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = MobilePhone2Light;

MobilePhone2Light.default = MobilePhone2Light;
